<script>
  import { onDestroy, onMount, tick } from "svelte";
  import DialogBase2 from "../../dialog/DialogBase2.svelte";
  import InitialStep from "./InitialStep.svelte";
  import DialogTitle from "../../dialog/DialogTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import SelectExistingUserStep from "./SelectExistingUserStep.svelte";
  import ManageRestrictionsForExistingUserStep from "./ManageRestrictionsForExistingUserStep.svelte";
  import ManageRestrictionsForNewUserStep from "./ManageRestrictionsForNewUserStep.svelte";
  import CopyInvitationLinkStep from "./CopyInvitationLinkStep.svelte";
  import DialogSplitter from "../../dialog/DialogSplitter.svelte";

  export let projectId

  /**
   * @type {
   *   | "initial"
   *   | "selectExistingUser"
   *   | "manageRestrictionsForExistingUser"
   *   | "manageRestrictionsForNewUser"
   *   | "copyInvitationLink"
   * }
   */
  export let currentPage = "initial"

  export let onClose

  // internal states
  let user = null
  let invitationId = null

  function moveToPage(nextPage) {
    currentPage = nextPage;
  }

  let dialog = null
  onMount(async () => {
    await tick()
    dialog?.showModal()
  })
  onDestroy(() => {
    dialog?.close()
  })
</script>

<DialogBase2 bind:dialog={dialog} width="700px">
  <DialogTitle>
    {translate("frontend:components.restrictedUserInvitationDialog.title")}
  </DialogTitle>
  <DialogSplitter />
  {#if currentPage === "initial"}
    <InitialStep
      projectId={projectId}
      moveNext={(selected) => moveToPage(selected === "newUser" ? "manageRestrictionsForNewUser" : "selectExistingUser")}
      closeDialog={onClose}
    />
  {:else if currentPage === "selectExistingUser"}
    <SelectExistingUserStep
      projectId={projectId}
      moveNext={(selectedUser) => {
        user = selectedUser
        moveToPage("manageRestrictionsForExistingUser")
      }}
      closeDialog={onClose}
    />
  {:else if currentPage === "manageRestrictionsForExistingUser"}
    <ManageRestrictionsForExistingUserStep
      projectId={projectId}
      user={user}
      closeDialog={onClose}
    />
  {:else if currentPage === "manageRestrictionsForNewUser"}
    <ManageRestrictionsForNewUserStep
      projectId={projectId}
      user={user}
      moveNext={async (id) => {
        invitationId = id
        currentPage = "copyInvitationLink"
      }}
      closeDialog={onClose}
    />
  {:else if currentPage === "copyInvitationLink"}
    <CopyInvitationLinkStep
      projectId={projectId}
      invitationId={invitationId}
      closeDialog={onClose}
    />
  {/if}
</DialogBase2>
